import script from "./sample-item.vue?vue&type=script&setup=true&lang=js"
export * from "./sample-item.vue?vue&type=script&setup=true&lang=js"

import "./sample-item.vue?vue&type=style&index=0&id=5b71c436&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b71c436"]])

export default __exports__